module.exports = __webpack_public_path__ + "img/headshotStewart.0a123967.png";